export { default } from "./CreateUser";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/CreateProcUser/index.js